import React from "react";
import PageLayout from "../components/navFoot/PageLayout";

const Documentation = () => {
  return (
    <PageLayout>
      <h1>Documentation</h1>
      <hr></hr>
      <h4>Coming Soon!...</h4>
    </PageLayout>
  );
};

export default Documentation;
